import React, { useEffect, useState } from 'react';
import {default as api} from '../../../store/apiSlice'

const ItemList = () => {

  const {data, isFetching, isError, isSuccess} = api.useGetLabelsQuery()
  const [deleteTranstion] = api.useDeleteTranstionMutation()



//console.log(data);


  //deletebtbn
  const deleteBtn=(e)=>{
    if(!e.target.dataset.id)return 0
    deleteTranstion({_id: e.target.dataset.id})

   console.log(e.target.dataset.id);
  }

  let Transaction;

  if(isFetching){
   Transaction = <div>Fetching</div>

  }else if(isSuccess){
 
   Transaction= <div>
    
     {
      
      data.map(v=> <tr key={v._id}>  

        <td>{v.name}</td>
        <td>{v.type}</td>
        <td>$ {v.amount}</td>
        <td>{v.date}</td>
        <td>
            <button onClick={deleteBtn} data-id={v._id??''} className='btn btn-xs'>
               x</button>
        </td>                    
      </tr>)
     }
   </div>
   
  }else if(isError){
   Transaction= 'Error'

  }

    return (
        <div>
            <h2 className='text-center text-xl font-semibold pb-2'>History</h2>
            <div className="itemList">             
            <div className="overflow-x-auto">
          <table className="table w-full">
            <tbody>
              {Transaction}  
      
           </tbody>
         </table>
       </div>
      </div>
    </div>
    );
};

export default ItemList;